export const GET_EXAM = 'GET_EXAM';
export const GET_EXAM_SUCCESS = 'GET_EXAM_SUCCESS';
export const GET_EXAM_FAILED = 'GET_EXAM_FAILED';

export const SAVE_EXAM = 'SAVE_EXAM';
export const SAVE_EXAM_SUCCESS = 'SAVE_EXAM_SUCCESS';
export const SAVE_EXAM_FAILED = 'SAVE_EXAM_FAILED';
